import React from 'react';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  standardColours,
  greyColours,
  brandColours,
  brandFonts,
  fontWeights,
  fontSize,
} from '../styles';
import { Image, Button } from './ui';
import { formatPrice } from '../utils';
// import tescoClubcard from '../images/tesco-clubcard.img.svg';
// import o2Priority from '../images/o2-priority.img.svg';
// import jenniferYoungLogo from '../images/jennifer-young-logo.jpg';
import { Link } from 'gatsby';

const StyledSpaCta = styled.article`
  display: flex;
  flex-direction: column;
  background-color: ${standardColours.white};
  border: 1px solid ${brandColours.primary};
`;

const StyledImages = styled.div`
  position: relative;
`;

const StyledImage = styled(Image)``;

const StyledLogo = styled(Image)`
  position: absolute;
  right: 10px;
  bottom: 10px;
`;

const StyledContent = styled.div`
  padding: 14px 25px;

  ${minBreakpointQuery.small`
    padding: 18px 30px;
  `}

  ${minBreakpointQuery.medium`
    padding: 22px 35px;
  `}

  ${minBreakpointQuery.large`
    padding: 26px 40px;
  `}
`;

const StyledLocation = styled.p`
  margin-bottom: 12px;
  color: ${brandColours.quinary};
`;

const StyledHeading = styled.h3`
  ${brandFonts.secondary};
  ${fontSize(24)};
  line-height: 1.1;

  ${minBreakpointQuery.tiny`
    ${fontSize(26)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(28)};
  `}
`;

const StyledSubheading = styled.h4`
  margin-top: 6px;
  font-weight: ${fontWeights.medium};
  ${fontSize(16)};
`;

const StyledText = styled.p`
  margin-top: 8px;
  color: ${greyColours.darkPurplishGrey};
  line-height: 1.4;
`;

const StyledPrice = styled.p`
  margin-top: 12px;
  color: ${greyColours.darkPurplishGrey};
  ${fontSize(14)};

  span {
    color: ${brandColours.primary};
    ${fontSize(18)};

    ${minBreakpointQuery.tiny`
      ${fontSize(20)};
    `}

    ${minBreakpointQuery.medium`
      ${fontSize(22)};
    `}

    ${minBreakpointQuery.large`
      ${fontSize(24)};
    `}
  }
`;

const StyledBadgeButton = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  margin: 10px;
  margin-top: auto;
`;

// const StyledBadge = styled.img`
//   margin: 0 10px 15px 30px;
//   max-height: 35px;
//   max-width: 70px;

//   ${minBreakpointQuery.small`
//     margin-bottom: 20px;
//     margin-left: 35px;
//   `}

//   ${minBreakpointQuery.large`
//     margin-bottom: 25px;
//     margin-left: 40px;
//   `}
// `;

const StyledButton = styled(Button)`
  align-self: flex-end;
`;

const SpaCta = ({
  image,
  logo,
  location,
  heading,
  subheading,
  text,
  minPrice,
  isPricePerPerson,
  link,
  affilateName,
}) => {
  // const badge =
  //   affilateName === 'Tesco Clubcard'
  //     ? tescoClubcard
  //     : affilateName === 'Priority Rewards'
  //     ? o2Priority
  //     : affilateName === 'Jennifer Young'
  //     ? jenniferYoungLogo
  //     : null;

  return (
    <StyledSpaCta>
      <StyledImages>
        <StyledImage
          src={image.url}
          alt={image.title}
          width={580}
          height={270}
          layout="constrained"
        />
        {logo && (
          <StyledLogo
            src={logo.url}
            alt={logo.title}
            width={86}
            height={30}
            layout="constrained"
          />
        )}
      </StyledImages>
      <StyledContent>
        {location && <StyledLocation>{location}</StyledLocation>}
        <StyledHeading>
          <Link to={link.url}>{heading}</Link>
        </StyledHeading>
        <StyledSubheading>{subheading}</StyledSubheading>
        <StyledText>{text}</StyledText>
        {minPrice && (
          <StyledPrice>
            From <span>{formatPrice(minPrice)}</span>{' '}
            {`per ${isPricePerPerson ? 'person' : 'package'}`}
          </StyledPrice>
        )}
      </StyledContent>
      <StyledBadgeButton>
        {/* {badge && <StyledBadge src={badge} alt={affilateName} loading="lazy" />} */}
        <StyledButton to={link.url} alt={true}>
          {link.text}
        </StyledButton>
      </StyledBadgeButton>
    </StyledSpaCta>
  );
};

export default SpaCta;
